var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_56","data-name":"Path 56","d":"M8.1,5.591H6v2.8H8.1v8.387h3.494V8.387h2.545l.25-2.8h-2.8V4.426c0-.667.134-.932.779-.932h2.016V0H11.725C9.212,0,8.1,1.106,8.1,3.225Z","transform":"translate(-6)","fill":"#fff"}));
}

Facebook.defaultProps = {"width":"8.387","height":"16.773","viewBox":"0 0 8.387 16.773"};

module.exports = Facebook;

Facebook.default = Facebook;
